import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: null,
  }),
  actions: {
    async getTheme() {
      try {
        let response = await this.$axiosInstance.get('/Configuration/Theme', {
          params: {
            global: true,
          },
        })

        if (response?.data?.data) this.theme = response.data.data || {}
      } catch (error) {
        if (!this.theme) this.theme = {}
        return error
      }
    },
    setTheme(theme)
    {
      this.theme=theme
    }
  },
})
